import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import PropTypes from 'prop-types';
import { Modal } from 'react-bootstrap';
import EmployerSignupPanel from '../Registration/EmployerSignupPanel';
import './RegistrationModal.scss';
function RegistrationModal(_ref) {
  var _ref$showModal = _ref.showModal,
    showModal = _ref$showModal === void 0 ? false : _ref$showModal,
    _ref$hideModal = _ref.hideModal,
    hideModal = _ref$hideModal === void 0 ? function () {} : _ref$hideModal,
    csrfToken = _ref.csrfToken,
    googleOmniauthUrl = _ref.googleOmniauthUrl,
    msOmniauthUrl = _ref.msOmniauthUrl,
    signInUrl = _ref.signInUrl,
    _ref$extraParams = _ref.extraParams,
    extraParams = _ref$extraParams === void 0 ? {} : _ref$extraParams,
    _ref$header = _ref.header,
    header = _ref$header === void 0 ? null : _ref$header,
    _ref$showTestimonials = _ref.showTestimonials,
    showTestimonials = _ref$showTestimonials === void 0 ? false : _ref$showTestimonials,
    location = _ref.location,
    _ref$inviterId = _ref.inviterId,
    inviterId = _ref$inviterId === void 0 ? null : _ref$inviterId,
    _ref$projectResourceI = _ref.projectResourceId,
    projectResourceId = _ref$projectResourceI === void 0 ? null : _ref$projectResourceI,
    _ref$invitedEmail = _ref.invitedEmail,
    invitedEmail = _ref$invitedEmail === void 0 ? null : _ref$invitedEmail;
  return /*#__PURE__*/React.createElement(Modal, {
    show: showModal,
    onHide: hideModal,
    dialogClassName: "style-guide registration-modal"
  }, /*#__PURE__*/React.createElement(Modal.Header, {
    closeButton: true
  }), /*#__PURE__*/React.createElement(Modal.Body, null, /*#__PURE__*/React.createElement(EmployerSignupPanel, _extends({
    csrfToken: csrfToken,
    googleOmniauthUrl: googleOmniauthUrl,
    msOmniauthUrl: msOmniauthUrl,
    signInUrl: signInUrl,
    showReferralPanel: false
  }, header && {
    header: header
  }, Object.keys(extraParams).length && {
    extraParams: extraParams
  }, {
    showTestimonials: showTestimonials,
    location: location,
    inviterId: inviterId,
    projectResourceId: projectResourceId,
    invitedEmail: invitedEmail
  }))));
}
RegistrationModal.propTypes = {
  showModal: PropTypes.bool,
  hideModal: PropTypes.func,
  csrfToken: PropTypes.string.isRequired,
  googleOmniauthUrl: PropTypes.string.isRequired,
  msOmniauthUrl: PropTypes.string.isRequired,
  signInUrl: PropTypes.string.isRequired,
  extraParams: PropTypes.shape({}),
  header: PropTypes.string,
  showTestimonials: PropTypes.bool,
  location: PropTypes.string.isRequired,
  inviterId: PropTypes.string,
  projectResourceId: PropTypes.string,
  requestCallbackChosen: PropTypes.bool,
  invitedEmail: PropTypes.string
};
export default RegistrationModal;